import React from "react";

const TYPES = [
  { key: "range", label: "I have a budget range" },
  { key: "hourly", label: "Hourly rate" },
  { key: "open", label: "Not sure — get quotes" },
];
const PRESETS = [[0, 150], [150, 500], [500, 1500], [1500, 5000], [5000, 15000]];

export default function BudgetStep({ req, set }) {
  return (
    <div className="space-y-6" data-testid="budget-step">
      <div>
        <div className="font-display text-xl font-semibold text-[#071b22]">Budget</div>
        <p className="text-sm text-[#252A34]/65 mt-1">A rough range helps pros send realistic estimates. You're never charged until you accept one.</p>
      </div>
      <div className="flex flex-wrap gap-2">
        {TYPES.map((t) => (
          <button type="button" key={t.key} onClick={() => set("budget_type", t.key)} className={`rounded-xl border px-4 py-2.5 text-sm transition-colors ${req.budget_type === t.key ? "border-[#165a71] bg-[#165a71] text-white" : "border-slate-200 bg-white hover:border-[#165a71]/50"}`} data-testid={`budget-type-${t.key}`}>{t.label}</button>
        ))}
      </div>
      {req.budget_type === "range" && (
        <>
          <div className="flex flex-wrap gap-2">
            {PRESETS.map(([a, b]) => (
              <button type="button" key={a} onClick={() => { set("budget_min", a); set("budget_max", b); }} className={`rounded-full border px-3 py-1.5 text-xs ${req.budget_min === a && req.budget_max === b ? "border-[#165a71] bg-[#165a71]/10" : "border-slate-200"}`} data-testid={`budget-preset-${a}`}>${a.toLocaleString()}–${b.toLocaleString()}</button>
            ))}
          </div>
          <div className="grid gap-3 grid-cols-2 max-w-md">
            <label><div className="text-xs mb-1 text-[#252A34]/70">Min ($)</div><input type="number" value={req.budget_min ?? ""} onChange={(e) => set("budget_min", e.target.value === "" ? null : Number(e.target.value))} className="sr-input" data-testid="budget-min" /></label>
            <label><div className="text-xs mb-1 text-[#252A34]/70">Max ($)</div><input type="number" value={req.budget_max ?? ""} onChange={(e) => set("budget_max", e.target.value === "" ? null : Number(e.target.value))} className="sr-input" data-testid="budget-max" /></label>
          </div>
        </>
      )}
      {req.budget_type === "hourly" && (
        <label className="block max-w-xs"><div className="text-xs mb-1 text-[#252A34]/70">Hourly rate ($)</div><input type="number" value={req.budget_hourly ?? ""} onChange={(e) => set("budget_hourly", e.target.value === "" ? null : Number(e.target.value))} className="sr-input" data-testid="budget-hourly" /></label>
      )}
    </div>
  );
}
